// frontend/src/pages/DocumentDetailPage.js

// import React, { useState, useEffect } from 'react';
// import { useParams, Link as RouterLink } from 'react-router-dom';
// import { Box, Typography, CircularProgress, Paper, List, ListItem, ListItemText, Chip, Button, Divider, Breadcrumbs, Link } from '@mui/material';
// import api from '../services/api';

// const DocumentDetailPage = () => {
//   const { id } = useParams(); // Pega o ID do documento da URL
//   const [documento, setDocumento] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [isDownloading, setIsDownloading] = useState(false);

//   useEffect(() => {
//     const fetchDocument = async () => {
//       try {
//         setLoading(true);
//         const response = await api.get(`/documentos/${id}/`);
//         setDocumento(response.data);
//       } catch (err) {
//         setError('Falha ao carregar o documento.');
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchDocument();
//   }, [id]);

//   const formatSignatureDate = (dateString) => {
//     if (!dateString) return 'Aguardando assinatura';
//     // Converte 'dd/MM/yyyy HH:mm' para um formato que o JS entende
//     const parts = dateString.split(/[\s/:]+/);
//     // Formato esperado: new Date(ano, mês-1, dia, hora, minuto)
//     const date = new Date(parts[2], parts[1] - 1, parts[0], parts[3], parts[4]);
    
//     // Verifica se a data é válida antes de formatar
//     return !isNaN(date.getTime()) ? date.toLocaleString('pt-BR') : 'Data inválida';
//   };

//   const getStatusChip = (status) => {
//     const statusMap = {
//         'PENDENTE': { label: 'Pendente', color: 'warning' },
//         'ASSINADO': { label: 'Assinado', color: 'success' },
//         'RECUSADO': { label: 'Recusado', color: 'error' },
//     };
//     const { label, color } = statusMap[status] || { label: status, color: 'default' };
//     return <Chip label={label} color={color} size="small" />;
//   };

//   const handleDownload = async () => {
//     setIsDownloading(true);
//     try {
//       // ### CORREÇÃO: Usando a nova variável 'documento' ###
//       const response = await api.get(documento.caminho_pdf_atual, {
//         responseType: 'blob',
//       });

//       const url = window.URL.createObjectURL(new Blob([response.data]));
      
//       // Aqui, 'document' se refere ao objeto global do navegador, que agora está acessível.
//       const link = document.createElement('a');
//       link.href = url;
      
//       const fileName = documento.caminho_pdf_atual.split('/').pop();
//       link.setAttribute('download', fileName);
      
//       document.body.appendChild(link);
//       link.click();
      
//       link.parentNode.removeChild(link);
//       window.URL.revokeObjectURL(url);

//     } catch (err) {
//       console.error("Erro ao baixar o arquivo", err);
//       alert("Não foi possível fazer o download do arquivo.");
//     } finally {
//       setIsDownloading(false);
//     }
//   };

//   if (loading) {
//     return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
//   }

//   if (error) {
//     return <Typography color="error" sx={{ p: 3 }}>{error}</Typography>;
//   }
//   if (!documento) {
//     return <Typography sx={{ p: 3 }}>Documento não encontrado.</Typography>;
//   }

//   if (!document) {
//     return <Typography sx={{ p: 3 }}>Documento não encontrado.</Typography>;
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
//         <Link component={RouterLink} underline="hover" color="inherit" to="/">
//           Meus Pedidos
//         </Link>
//         <Typography color="text.primary">Detalhes</Typography>
//       </Breadcrumbs>

//       <Paper elevation={3} sx={{ p: 3 }}>
//         {/* ### CORREÇÃO: Usando a nova variável em todo o JSX ### */}
//         <Typography variant="h4" gutterBottom>{documento.descricao}</Typography>
//         <Divider sx={{ my: 2 }} />
//         <Typography variant="h6">Status dos Assinantes</Typography>
//         <List>
//           {documento.pedidos_assinatura && documento.pedidos_assinatura.map(pedido => (
//             <ListItem key={pedido.id} secondaryAction={getStatusChip(pedido.status)}>
//               <ListItemText 
//                 primary={pedido.assinante_nome}
//                 secondary={`Data: ${formatSignatureDate(pedido.data_assinatura)}`}
//               />
//             </ListItem>
//           ))}
//         </List>
//         <Divider sx={{ my: 2 }} />
//         {documento.status === 'CONCLUIDO' && (
//           <Button 
//             variant="contained" 
//             color="success"
//             onClick={handleDownload}
//             disabled={isDownloading}
//           >
//             {isDownloading ? 'Baixando...' : 'Fazer Download do Documento Final'}
//           </Button>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default DocumentDetailPage;

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { FaFileDownload } from 'react-icons/fa';
import { getSingleDocument, deleteDocument } from '../services/api';
import { useNotification } from '../context/NotificationContext';

const DocumentDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [document, setDocument] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const fetchDocument = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getSingleDocument(id);
      setDocument(response.data);
    } catch (err) {
      setError('Documento não encontrado ou falha ao carregar.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchDocument();
  }, [fetchDocument]);

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true);
      await deleteDocument(id);
      setConfirmOpen(false);
      showSuccess(`Documento "${document?.descricao || ''}" excluído definitivamente.`);
      navigate('/');
    } catch (err) {
      console.error('Erro ao excluir documento:', err);
      showError('Não foi possível excluir o documento. Tente novamente.');
    } finally {
      setIsDeleting(false);
    }
  };
  
  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
  }

  if (error) {
    return <Typography color="error" sx={{ textAlign: 'center', p: 4 }}>{error}</Typography>;
  }

  if (!document) {
    return null;
  }
  
  const formattedCreationDate = new Date(document.criado_em).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

  return (
    <Box sx={{ p: 3 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/')} sx={{ mb: 2 }}>
        Voltar para o Dashboard
      </Button>
      
      <Paper elevation={3} sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 2 }}>
          <Typography variant="h4">{document.descricao}</Typography>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            {document.status === 'CONCLUIDO' && (
              <Button variant="contained" startIcon={<FaFileDownload />} href={document.caminho_pdf_atual} target="_blank">
                Download
              </Button>
            )}
            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteOutlineIcon />}
              onClick={() => setConfirmOpen(true)}
            >
              Excluir Documento
            </Button>
          </Box>
        </Box>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Criado em: {formattedCreationDate} | Status: <strong>{document.status.replace('_', ' ')}</strong>
        </Typography>
        
        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>Status das Assinaturas</Typography>
        <List>
          {document.pedidos_assinatura.map((signer, index) => {
            const signatureDate = signer.data_assinatura
              ? new Date(signer.data_assinatura).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
              : '--';
            
            let statusIcon;
            let statusColor = 'text.secondary';
            if (signer.status === 'ASSINADO') {
              statusIcon = <CheckCircleIcon color="success" />;
              statusColor = 'success.main';
            } else if (signer.status === 'RECUSADO') {
              statusIcon = <CancelIcon color="error" />;
              statusColor = 'error.main';
            } else {
              statusIcon = <HourglassEmptyIcon color="disabled" />;
            }

            return (
              <React.Fragment key={signer.id}>
                <ListItem>
                  <ListItemText 
                    primary={
                      <Typography variant="body1" component="span" sx={{ fontWeight: 'bold' }}>
                        {signer.assinante_nome}
                      </Typography>
                    }
                    secondary={
                      <Box component="span" sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                        {statusIcon}
                        <Typography component="span" variant="body2" sx={{ ml: 1, color: statusColor }}>
                          {signer.status.replace('_', ' ')}
                        </Typography>
                        <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 2 }}>
                          {signer.status !== 'PENDENTE' && `em ${signatureDate}`}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
                {index < document.pedidos_assinatura.length - 1 && <Divider component="li" />}
              </React.Fragment>
            );
          })}
        </List>
      </Paper>

      <Dialog
        open={confirmOpen}
        onClose={() => !isDeleting && setConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main', fontWeight: 700 }}>
          <WarningAmberRoundedIcon color="error" />
          Excluir Documento Definitivamente?
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Você está prestes a excluir o documento <strong>"{document.descricao}"</strong>.
          </Typography>
          <Alert severity="error" variant="outlined" sx={{ mb: 1 }}>
            <strong>Atenção:</strong> Esta ação é irreversível! Ao confirmar, você <strong>perderá definitivamente</strong> este documento e todo o histórico de assinaturas do sistema.
          </Alert>
          {document.status === 'CONCLUIDO' ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5 }}>
              Certifique-se de que você já realizou o download do arquivo PDF assinado antes de excluí-lo.
            </Typography>
          ) : (
            <Typography variant="caption" color="warning.dark" sx={{ display: 'block', mt: 1.5, fontWeight: 500 }}>
              Este documento ainda está com status "{document.status.replace('_', ' ')}". Os assinantes pendentes não poderão mais assiná-lo.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            disabled={isDeleting}
            variant="outlined"
            color="inherit"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={isDeleting}
            variant="contained"
            color="error"
            startIcon={isDeleting ? <CircularProgress size={18} color="inherit" /> : <DeleteForeverIcon />}
          >
            {isDeleting ? 'Excluindo...' : 'Excluir Definitivamente'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DocumentDetailPage;